import { useCallback, useState } from 'react';

/**
 * Temporary CCIMPORTER-6642 backend stub. Choices belong to created reviews, not
 * the editor form. They survive closing the pane but reset with the provider.
 * This does not persist intent on the server or perform publication.
 * Replace with autoPublishEnabled in both create inputs and review query outputs,
 * then regenerate the Relay artifacts when the backend schema is available.
 */
export const useAutoPublishBackendStub = (): {
	savedChoices: Readonly<Record<string, boolean>>;
	saveChoice: (reviewId: string | null | undefined, enabled: boolean) => void;
} => {
	const [savedChoices, setSavedChoices] = useState<Readonly<Record<string, boolean>>>({});
	const saveChoice = useCallback((reviewId: string | null | undefined, enabled: boolean) => {
		if (!reviewId) return;
		setSavedChoices((choices) => ({ ...choices, [reviewId]: enabled }));
	}, []);

	return { savedChoices, saveChoice };
};
